var AZURE_SERVICE_ITEM = {
    title: 'Services for Azure',
    icon: 'AzureFill',
    description: 'Find an expert for products like Virtual Machine images, Azure apps, and more.',
    navigateOptions: {
        type: 'Service',
        query: {
            product: 'azure'
        }
    }
};
var CONSULTING_SERVICES_ITEMS = [
    {
        title: 'Services for Microsoft 365',
        icon: 'Microsoft365',
        description: 'Find an expert for products like Excel, Outlook, Teams, and more.',
        navigateOptions: {
            type: 'Service',
            query: {
                product: 'office'
            }
        }
    },
    {
        title: 'Services for Power Platform',
        icon: 'PowerPlatform',
        description: 'Find an expert for products like Power BI, Power Apps, Power Automate, and more.',
        navigateOptions: {
            type: 'Service',
            query: {
                product: 'power-platform'
            }
        }
    },
    {
        title: 'Services for Dynamics 365',
        icon: 'Dynamics365',
        description: 'Find an expert for products like Sales, Customer Service, Business Central, and more.',
        navigateOptions: {
            type: 'Service',
            query: {
                product: 'dynamics-365'
            }
        }
    }
];

export { AZURE_SERVICE_ITEM, CONSULTING_SERVICES_ITEMS };
